module.exports = __webpack_public_path__ + "assets/img/home_bg_i.646f8fa1.png";